import { notification, Modal } from 'antd';
import { TaxCouponUpdadeCodeRequest } from '../coupons/coupons.types';

export const managerCouponsError: Record<number, string> = {
  4000: 'Ativado corretamente',
  4001: 'Erro na criação do certificado',
  4002: 'SEFAZ não reconhece este SAT (CNPJ inválido)',
  4003: 'SAT/AC SAT já ativado ou pendente de Vinculação do AC',
  4004: 'SAT com uso cessado',
  4005: 'Erro de comunicação com a SEFAZ ',
  4006: 'CSR ICP-BRASIL criado com sucesso',
  4007: 'Erro na criação do CSR ICP-BRASIL',
  4098: 'SAT em processamento. Tente novamente.',
  4099: 'Erro desconhecido na ativação',
  6000: 'Emitido com sucesso + conteúdo notas.',
  6001: 'Código de ativação inválido.',
  6002: 'SAT ainda não ativado.',
  6003: 'SAT não vinculado ao AC ',
  6004: 'Vinculação do AC não confere',
  6005: 'Tamanho do CF-e-SAT superior a 1.500KB',
  6006: 'SAT bloqueado pelo contribuinte',
  6007: 'SAT bloqueado pela SEFAZ',
  6008: 'SAT bloqueado por falta de comunicação',
  6009: 'SAT bloqueado, código de ativação incorreto',
  6010: 'Erro de validação do conteúdo.',
  6098: 'SAT em processamento. Tente novamente.',
  6099: 'Erro desconhecido na emissão.',
  7000: 'Cupom cancelado com sucesso + conteúdo CFe-SAT cancelado.',
  7001: 'Código ativação inválido',
  7002: 'Cupom inválido',
  7003: 'SAT bloqueado pelo contribuinte',
  7004: 'SAT bloqueado pela SEFAZ',
  7005: 'SAT bloqueado por falta de comunicação',
  7006: 'SAT bloqueado, código de ativação incorreto',
  7007: 'Erro de validação do conteúdo',
  7098: 'SAT em processamento.  Tente novamente.',
  7099: 'Erro desconhecido no cancelamento.',
  8000: 'SAT em operação.',
  8098: 'SAT em processamento.  Tente novamente.',
  8099: 'Erro desconhecido.',
  9000: 'Emitido com sucesso',
  9001: 'código ativação inválido',
  9002: 'SAT ainda não ativado.',
  9098: 'SAT em processamento. Tente novamente.',
  9099: 'Erro desconhecido',
  10000: 'Resposta com Sucesso.',
  10001: 'Código de ativação inválido',
  10098: 'SAT em processamento. Tente novamente.',
  10099: 'Erro desconhecido ',
  11000: 'Retorno da sessão processada',
  11001: 'Código ativação inválido ',
  11002: 'SAT ainda não ativado.',
  11003: 'Sessão não existe.',
  11098: 'SAT em processamento. Tente novamente.',
  11099: 'Erro desconhecido.',
  12000: 'Rede Configurada com Sucesso',
  12001: 'Código ativação inválido',
  12002: 'Dados fora do padrão a ser informado',
  12098: 'SAT em processamento. Tente novamente.',
  12099: 'Erro desconhecido',
  13000: 'Assinatura do AC Registrada',
  13001: 'Código ativação inválido ',
  13002: 'Erro de comunicação com a SEFAZ',
  13003: 'Assinatura fora do padrão informado ',
  13004:
    'CNPJ da Software House + CNPJ do emitente assinado no campo “signAC” difere do informado no campo “CNPJvalue”',
  13007: 'CNPJ do emitente difere daquele constante da parametrização de uso.',
  13098: 'SAT em processamento. Tente novamente.',
  13099: 'Erro desconhecido',
  14000: 'Software Atualizado com Sucesso',
  14001: 'Código de ativação inválido.',
  14002: 'Atualização em Andamento',
  14003: 'Erro na atualização',
  14004: 'Arquivo de atualização inválido',
  14098: 'SAT em processamento.  Tente novamente.',
  14099: 'Erro desconhecido ',
  15000: 'Transferência completa',
  15001: 'Código de ativação inválido.',
  15002: 'Transferência em andamento',
  15098: 'SAT em processamento.  Tente novamente.',
  15099: 'Erro desconhecido',
  16000: 'Equipamento SAT bloqueado com sucesso.',
  16001: 'Código de ativação inválido.',
  16002: 'Equipamento SAT já está bloqueado.',
  16003: 'Erro de comunicação com a SEFAZ',
  16004:
    'Não existe parametrização de bloqueio disponível. Verifique configurações na SEFAZ',
  16098: 'SAT em processamento. Tente novamente.',
  16099: 'Erro desconhecido',
  17000: 'Equipamento SAT desbloqueado com sucesso.',
  17001: 'Código de ativação inválido.',
  17002: 'SAT bloqueado pelo contribuinte. Verifique configurações na SEFAZ',
  17003: 'SAT bloqueado pela SEFAZ',
  17004: 'Erro de comunicação com a SEFAZ',
  17098: 'SAT em processamento.',
  17099: 'Erro desconhecido ',
  18000: 'Código de ativação alterado com sucesso.',
  18001: 'Código de ativação inválido.',
  18002: 'Código de ativação de emergência Incorreto.',
  18098: 'SAT em processamento. Tente novamente.',
  18099: 'Erro desconhecido',
  1004: 'Validação se o leiaute está dentre os aceitos pelo SAT',
  1005: 'Validação se o leiaute de entrada está dentre os aceitos pelo SAT, porém não é a atual',
  1226: 'Código da UF do Emitente diverge da UF receptora.',
  1450: 'Validação se Código diferente de 59',
  1258: 'Validação se data/hora é anterior à data/hora do último CF-e-SAT emitido ou cancelado',
  1224: 'CNPJ com zeros, nulo ou DV inválido',
  1455: 'Assinatura do Aplicativo Comercial não é válida.',
  1207: 'CNPJ do emitente: com zeros, nulo ou DV inválido.',
  1203: 'CNPJ do emitente não corresponde ao contribuinte autorizado para uso do SAT',
  1229: 'IE Emitente com zeros ou nulo',
  1230: 'IE não corresponde ao Contribuinte de uso do SAT',
  1457: 'Regime Especial de Tributação do ISSQN diferente de 1, 2, 3, 4 e 5',
  1507: 'Indicador de rateio do Desconto/Acréscimo sobre subtotal entre itens sujeitos à tributação pelo ISSQN.',
  1235: 'CNPJ do destinatário com zeros, dígito de controle inválido ou igual ao do emitente do CF-e-SAT',
  1237: 'E03 CPF do destinatário com zeros ou dígito de controle inválido',
  1019: 'Validação se numeração dos itens é crescente',
  1459: 'Descrição do produto ou serviço em branco',
  1460: 'GTIN não é válido',
  1461: 'Descrição do produto ou serviço em branco',
  1462: 'CFOP não é válido para CFe-SAT (diferente de 5xxx)',
  1463: 'Unidade Comercial do produto ou serviço em branco',
  1464: 'Quantidade comercial não é maior ou igual a zero',
  1465: 'Valor unitário não é maior ou igual a zero',
  1467: 'Regra de cálculo inválida (diferente de “A” e “T”)',
  1468: 'Valor do Desconto sobre item não é maior ou igual a zero',
  1469: 'Outras despesas acessórias sobre item não é maior ou igual a zero',
  1535: 'Código da credenciadora de cartão de débito ou crédito diferente dos previstos no Anexo 3',
  1220: 'Valor do rateio do Desconto sobre subtotal não é maior que zero',
  1228: 'Valor do rateio do acréscimo sobre subtotal não é maior que zero',
  1534: 'Valor não é maior ou igual a zero.',
  1533: 'Valor não é maior ou igual a zero.',
  1471: 'Origem da mercadoria inválida (diferente de 0, 1, 2, 3, 4, 5, 6, 7, 8)',
  1472: 'Tributação do ICMS inválida (diferente de 00, 20, 90)',
  1473: 'Alíquota efetiva do imposto não é maior ou igual a zero.',
  1475: 'Tributação do ICMS inválida (diferente de 40 e 41 e 60)',
  1476: 'Código de Situação da Operação – Simples Nacional inválido (diferente de 102, 300, 400 e 500)',
  1477: 'Código de Situação da Operação – Simples Nacional inválido (diferente de 900)',
  1478: 'Código de Situação Tributária do PIS Inválido (diferente de 01, 02 e 05)',
  1479: 'Validação de número positivo ou igual a zero.',
  1480: 'Validação de número positivo ou igual a zero.',
  1482: 'Código de Situação Tributária do PIS Inválido (diferente de 03)',
  1483: 'Validação de número positivo ou igual a zero.',
  1484: 'Validação de número positivo ou igual a zero.',
  1486: 'Código de Situação Tributária do PIS Inválido(diferente de 04, 06, 07, 08 e 09)',
  1487: 'Código de Situação Tributária do PIS inválido (diferente de 49)',
  1488: 'Código de Situação Tributária do PIS Inválido (diferente de 99)',
  1490: 'Código de Situação Tributária da COFINS Inválido (diferente de 01, 02 e 05)',
  1491: 'Validação de número positivo ou igual a zero.',
  1492: 'Validação de número positivo ou igual a zero.',
  1494: 'Código de Situação Tributária da COFINS Inválido (diferente de 03)',
  1496: 'Validação de número positivo ou igual a zero.',
  1498: 'Código de Situação Tributária da COFINS Inválido (diferente de 04, 06, 07, 08 e 09)',
  1499: 'Código de Situação Tributária da COFINS Inválido (diferente de 49)',
  1500: 'Código de Situação Tributária da COFINS Inválido (diferente de 99)',
  1501: 'Informado grupo de tributação do ISSQN (id:U01) sem informar a IM (id:C13)',
  1503: 'Validação de número positivo ou igual a zero.',
  1505: 'Validação de número maior ou igual a 2,00 (2%) e menor ou igual a 5,00 (5%).',
  1287: 'Validação se Código do Município do FG – ISSQN com dígito inválido. Exceto os códigos descritos no Anexo 2 que apresentam dígito inválido.',
  1509: 'Se informada TAG, validação de código diferente de brancos.',
  1510: 'Natureza da Operação de ISSQN diferente de 1, 2, 3, 4, 5, 6, 7 e 8',
  1511: 'Indicador de Incentivo Fiscal do ISSQN diferente de 1 e 2',
  1527: 'Código do Meio de Pagamento empregado para quitação do CF-e-SAT',
  1528: 'Valor do Meio de Pagamento empregado para quitação do CF-e-SAT, número menor ou igual a zero',
  1408: 'Validação se totalizador menor ou igual ao somatório dos valores de Meio de Pagamento (id:VA03)',
  1409: 'Validação se conteúdo menor ou igual ao máximo permitido no arquivo de Parametrização de Uso',
  1073: 'Se informada TAG, validação de número positivo ou igual a zero.',
  1074: 'Se informada TAG, validação de número positivo ou igual a zero.',
  1084: 'Formato do Certificado Inválido',
  1998: 'Dados de entrada resultam em valores negativos.',
  1999: 'Erro desconhecido',
};

export async function validateCouponReturn(
  dataString: string,
  updateCode: (data: TaxCouponUpdadeCodeRequest) => Promise<string>,
  couponId?: string,
) {
  if (dataString.includes('Emitido com sucesso')) {
    notification.success({
      message: 'Cupom emitido com sucesso!',
    });

    const sefazReferenceCode = dataString.split(',')[1];

    if (couponId) {
      await updateCode({ sefazReferenceCode, couponId });
    }
  } else if (dataString.includes('Rejeição')) {
    const errorCode = dataString.split(',')[2];
    const description = dataString.split('Rejeição:')[1];

    if (errorCode && managerCouponsError[Number(errorCode)]) {
      notification.error({
        message: 'Cupom rejeitado',
        description: managerCouponsError[Number(errorCode)],
      });
    } else {
      notification.error({ message: 'Cupom rejeitado', description });
    }
  } else if (dataString.includes('EXCEPTION')) {
    const description = dataString.split(',')[2];
    const descriptionList = description?.split('* ');

    let content = [<div>{description}</div>];

    if (descriptionList.length) {
      content = descriptionList.map((description) => <div>{description}</div>);
    }

    Modal.error({
      icon: null,
      width: 600,
      title: <span style={{ color: 'firebrick' }}>Cupom rejeitado</span>,
      content,
      okText: 'Fechar',
    });
  } else {
    notification.error({ message: 'Erro no envio do cupom' });
  }
}
